module.exports = __webpack_public_path__ + "static/media/Rover.cec572f9.logo";